import styled from 'styled-components';
import { ReactComponent as CloseIconElement } from "assets/svgs/closeIcon.svg";
import { colors } from 'colors';

export const Wrapper = styled.div`
  display: flex;
  align-items: center;
  padding: 32px 48px;
  margin: 32px;
  max-width: 256px;

  color: ${colors.white};
  box-shadow: 2px 2px 8px ${colors.silver};
  svg {
    fill: ${colors.white};
  }

  &[data-type="success"] {
    background-color: ${colors.jungleGreen};
    border: 1px solid ${colors.jungleGreen};
  }

  &[data-type="info"] {
    background-color: ${colors.brightBlue};
    border: 1px solid ${colors.brightBlue};
  }

  &[data-type="error"] {
    background-color: ${colors.lipstick};
    border: 1px solid ${colors.lipstick};
  }
`;

export const CloseIcon = styled(CloseIconElement)`
  position: absolute;
  cursor: pointer;
  top: 44px;
  right: 44px;
  padding: 8px;
  width: 8px;
`;
